import { Button } from "components/DesignSystem/Button/Button";
import { VendorEmailRequestModal } from "components/Vendors/VendorEmailRequestModal";
import { useModal } from "hooks/useModal";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";

export const RequestedVendorEmailCTA = ({
  customData,
  messageId,
}: {
  customData: CustomData;
  messageId: string;
}) => {
  const {
    submitted_count: submittedCount = 0,
    merchant_count: merchantCount = 0,
    merchant_details: merchantDetails,
    task_id: taskId = "",
    season = "",
  } = customData.metadata || {};

  const emailRequestModal = useModal();
  const areAllEmailsSubmitted = submittedCount === merchantCount;

  return (
    <>
      <VendorEmailRequestModal
        show={emailRequestModal.isOpen}
        closeModal={emailRequestModal.close}
        merchantIds={merchantDetails?.map(({ uuid }) => uuid).join(",") || ""}
        taskId={taskId}
        season={season}
        messageId={messageId}
        merchantCount={merchantCount}
        submittedCount={submittedCount}
      />
      <Button block size="small" onClick={emailRequestModal.open}>
        {areAllEmailsSubmitted ? "View" : "Add"}
      </Button>
    </>
  );
};
